(function () {
  angular.module("akitabox.serviceRequest.list", [
    "ui.router",
    "akitabox.constants",
    "akitabox.core.router",
    "akitabox.core.services.request",
  ]);
})();
